import {AfterViewInit, Component, effect, ElementRef, inject, viewChild, ChangeDetectionStrategy} from '@angular/core';
import {InnerScrollableComponent, screenSize, TemplateForDirective, ViewScrolling} from "@mindpath/shared";
import {HeaderComponent} from "./header/header.component";
import {FooterComponent} from "./footer/footer.component";
import {EventType, RouterLink, RouterOutlet} from "@angular/router";
import {NavService} from "../../services/nav.service";
import {ExtendedModule, FlexModule} from "@ngbracket/ngx-layout";
import {config} from "../../../config";

@Component({
  selector: 'app-page-view',
  imports: [
    InnerScrollableComponent,
    TemplateForDirective,
    HeaderComponent,
    FooterComponent,
    RouterOutlet,
    FlexModule,
    RouterLink,
    ExtendedModule
  ],
  templateUrl: './page-view.component.html',
  styleUrl: './page-view.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ViewScrolling]
})
export class PageViewComponent implements AfterViewInit {

  protected wizardElement = viewChild.required<ElementRef<HTMLDivElement>>('wizard');
  protected backBtn = viewChild<ElementRef<HTMLButtonElement>>('backBtn');
  protected readonly navSvc = inject(NavService);
  #viewScroller = inject(ViewScrolling);

  backLinkIsAction(link: string|(()=>void)): link is ()=>void {
    return typeof link === 'function';
  }

  protected readonly config = config;
  protected readonly screenSize = screenSize;

  constructor() {

    effect(() => {
      // const wizard  = this.wizardElement();
      if (this.navSvc.routerState() === EventType.NavigationEnd) {

        setTimeout(() => {
          this.#viewScroller.scrollToTop();
        }, 150);
      }
    });
  }

  #scrollToTop() {
    this.wizardElement()?.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });

  }

  ngAfterViewInit() {
    this.#scrollToTop();
  }

}
